<div class="ct_dashboard_main">
    <div class="ct_dashboard_right">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-9 mb-4">
                    <div class="ct_emission_menu_link">
                        <ul class="ps-0 mb-0">
                            <li>
                                <a >Finance Emissions</a>
                            </li>
                         
                        </ul>
                    </div>
                </div>
          
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-xl-9 mb-4">
                    
                        </div>
                        <div class="col-xl-3 mb-4 ct_mt_top_68">
                    
                            <div class="ct_right_sidebar">
                                <div class="mb-4">
                                    <div>
                                        <!-- <select class="ct_all_vender_select" [(ngModel)]="selectedSubGrupId"
                                            (change)="onFacilityChange($event)">
                                            <option value="" *ngFor="let items of dashboardData" [value]="items.ID">{{items.name}}
                                            </option>
                    
                                        </select> -->
                                        <ng-container  >
                                            <p-dropdown class="ct_select_op_input ct_chev_icon_dark230" required  #country="ngModel"
                                            [options]="groupsData" optionLabel="name" 
                                            optionValue="id" [(ngModel)]="selectedSubGrupId" [ngModelOptions]="{standalone: true}" [scrollable]="true"
                                            (onChange)="onFacilityChange($event)">
                                            <ng-template let-option pTemplate="item">
                                                <div class="d-flex justify-content-between">
                                                  <div>{{ option.name }}</div>
                                                  <div class="d-flex justify-content-end pt-1 ml-1">
                                                    <i class="fa" [class.fa-users]="option.group_by ==2" [class.fa-user]="option.group_by ==0"></i>
                                                  </div>
                                                </div>
                                              </ng-template>
                                        </p-dropdown>
                                        </ng-container>
                                        <div class="mt-4">
                                            <p class="mb-1 ct_fw_500">Financial Year</p>
                                            <p-calendar class="w-100 ct_input_dark_text_145" [(ngModel)]="year" ngModel name="year" year
                                                view="year" dateFormat="yy" inputId="yearpicker" styleClass="pcalender"
                                                (ngModelChange)="onFacilityChange($event)" [showIcon]="true"></p-calendar>
                                            <!-- <select class="ct_period_select w-100">
                                                <option value="">2023-2024</option>
                                                <option value="">2023-2024</option>
                                            </select> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                    
                                <div class="col-xl-4 mb-4">
                                    <div class="ct_grey_border_1 ">
                                        <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                                            <div>
                                                <h5 class="ct_font_16">Finance Emission</h5>
                                                <h3 class="ct_fs_24">{{airTotal | number:'1.2-2'}}</h3>
                                                <p class="mb-0">tCO2e</p>
                                            </div>
                                        </div>
                                        <div id="By_employee_location" *ngIf="pieChart">
                                            <apx-chart [series]="pieChart.series" [chart]="pieChart.chart"
                                                [labels]="pieChart.labels" [legend]="pieChart.legend"
                                                [responsive]="pieChart.responsive" [colors]="pieChart.colors"></apx-chart>
                                        </div>
                                    </div>
                                </div>
                            
                                <div class="col-xl-4 mb-4">
                                    <div class="ct_grey_border_1">
                                        <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                                            <div>
                                                <h5 class="ct_font_16">Industry</h5>
                                                <h3 class="ct_fs_24">{{renewableTotal}}</h3>
                                                <p class="mb-0">tCO2e</p>
                                            </div>
                    
                                        </div>
                                        <div id="ct_emission_by_travel" *ngIf="donotOptions1">
                                            <apx-chart [series]="donotOptions1.series" [chart]="donotOptions1.chart"
                                                [labels]="donotOptions1.labels" [legend]="donotOptions1.legend"
                                                [colors]="donotOptions1.colors" [responsive]="donotOptions1.responsive"></apx-chart>
                                        </div>
                                    </div>
                                </div>
                    
                            </div>
                    
                        </div>
                    </div>
                </div>
            </div>

           

        </div>

    </div>
</div>


